export default "__VITE_ASSET__DMrE$KmQ__"